module.exports = __webpack_public_path__ + "3d0ade9c71252b79572ce3c94931d4dc.png";